// extracted by mini-css-extract-plugin
export default {"LoadError":"bfx_a bik_qs bik_a bik_w bik_j bik_q","LoadError__icon":"bfx_b bik_vl bik_fm bik_sw","LoadError__message":"bfx_c bik_fm bik_tr"};